import { DateAdapter } from '@myphx-engineering/date-utils/client';

import { getFragment } from '../../graphql';
import type { PatientInfoFragment } from '../../graphql/generated/graphql';

export const getMemberId = (member: PatientInfoFragment) => {
    const memberIds: string[] = [];
    member.coveragesConnection.edges.forEach((edge) => {
        const coverage = getFragment(edge.coverage);
        if (!DateAdapter.isInDateRange(coverage.startDate, coverage.endDate)) {
            return;
        }

        if (edge.node.__typename === 'PhxBenefitsPlan') {
            memberIds.unshift(coverage.familyId);
            return;
        }

        memberIds.push(coverage.memberId);
    });

    return memberIds.length > 0 ? memberIds[0] : null;
};
